import { render, staticRenderFns } from "./ComingUpItem.vue?vue&type=template&id=9f7e8544"
import script from "./ComingUpItem.vue?vue&type=script&lang=js"
export * from "./ComingUpItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports